module.exports = __webpack_public_path__ + "img/duration.f2476ffa.svg";